import { SubscriptionStatus } from '@brighterly/lib-core-types/subscription/enums'

import { useSubscriptionStore } from '@stores/subscription'

import { safeLocalStorage } from '@helpers/safe-local-storage'

export async function useStoreSubscriptionActions (getFailedSubscription: () => Promise<any>) {
  const subscriptionStore = useSubscriptionStore()
  const data = await getFailedSubscription()
  const status = data?.subscription?.status

  if (status === SubscriptionStatus.Failed) {
    subscriptionStore.setBannerPaymentRetry(true)
    subscriptionStore.setBannerPaymentRetryProcessing(false)
  } else if (status === SubscriptionStatus.Retrying) {
    const bannerPaymentRetryProcessing = safeLocalStorage.getItem('bannerPaymentRetryProcessing')
    const isStorageRetrying = bannerPaymentRetryProcessing === SubscriptionStatus.Retrying

    subscriptionStore.setBannerPaymentRetry(false)
    subscriptionStore.setRetryPaymentModal(false)

    subscriptionStore.setBannerPaymentRetryProcessing(true)

    if (!isStorageRetrying) {
      subscriptionStore.setModalRetryPaymentProcessing(true)
    }

    safeLocalStorage.setItem('bannerPaymentRetryProcessing', SubscriptionStatus.Retrying)
  } else {
    subscriptionStore.setBannerPaymentRetry(false)
    subscriptionStore.setRetryPaymentModal(false)

    subscriptionStore.setBannerPaymentRetryProcessing(false)
    subscriptionStore.setModalRetryPaymentProcessing(false)

    subscriptionStore.setModalPaymentRetrySuccess(false)

    subscriptionStore.setPaymentRetryData(null)

    safeLocalStorage.removeItem('bannerPaymentRetryProcessing')
  }
}
